import type { ComponentShape, ShapeVertex, SizeMm } from '@repo/api-contracts';
import { roundMm } from './drawn-shape';

export type PolygonShape = Extract<ComponentShape, { type: 'polygon' }>;

/** 다각형 모양(바깥 고리·곡선 손잡이·구멍)을 가로·세로 비율대로 늘이거나 줄인다. 결과의 외접 크기는 `to` 와 같다. */
export const scalePolygonShape = (shape: PolygonShape, from: SizeMm, to: SizeMm): PolygonShape => {
  const sx = to.widthMm / from.widthMm;
  const sy = to.heightMm / from.heightMm;
  const scale = (point: { xMm: number; yMm: number }) => ({
    xMm: roundMm(point.xMm * sx),
    yMm: roundMm(point.yMm * sy),
  });
  const scaleVertex = (point: ShapeVertex): ShapeVertex => ({
    ...scale(point),
    ...(point.handleIn === undefined ? {} : { handleIn: scale(point.handleIn) }),
    ...(point.handleOut === undefined ? {} : { handleOut: scale(point.handleOut) }),
  });
  const scaled: PolygonShape = { ...shape, points: shape.points.map(scaleVertex) };
  if (shape.holes) return { ...scaled, holes: shape.holes.map((hole) => hole.map(scaleVertex)) };
  return scaled;
};
